import { getMenuAuth } from "src/apis/authApi";
import {  useCallback, useEffect } from "react";
import {  getPRD3031_R01List,   getPRD3031_R01AllCount } from "./Api_PRD3031_R01"
import useActionbarAuthStore from "src/store/useActionbarAuthStore";
import useMenuGlobalStore from "src/store/useMenuStore";
import { downloadExcel } from "src/utils/blob/blobUtil";
import { exportPRD3031_R01Excel } from "./Api_PRD3031_R01";
import { useLoadingSpinnerStore } from "src/store/util/loadingSpinnerUtil";
import useFetchActionbarAuth from "src/hooks/useFetchActionbarAuth";
import { ShowSuccessFetch, showWarning } from "src/utils/toast/toastUtil";

import { usePRD3031_R01Store, defaultPRD3031_R01Filter, PRD3031_R01Filter, ExtendedPRD3031_R01Dto } from "./Store_PRD3031_R01";
import { PRD3031_R01Dto } from "./Dto_PRD3031_R01";
import { fetchFilterConfig } from "src/utils/grid/GridHandlerContent";


interface ProductResultContentProps {
    setMessage: (message: string) => void;
}

export const Content_PRD3031_R01 = (props: ProductResultContentProps) => {
    const {
		setMessage,
    } = props;

	const { 
		PRD3031_R01Filter, setPRD3031_R01Filter,
		PRD3031_R01PastFilter, setPRD3031_R01PastFilter,
		PRD3031_R01List, setPRD3031_R01List, 
		setAllCount,
		setScrollTop,
	} = usePRD3031_R01Store();
	const { setLoadingSpinner } = useLoadingSpinnerStore();
    const { selectedThirdMenu } = useMenuGlobalStore();
    const menuCdStore = selectedThirdMenu?.menuCd;
    const setAuth = useActionbarAuthStore((state) => state.setAuth);

	useFetchActionbarAuth("PRD3031_R01");

    useEffect(() => {
        getMenuAuth("PRD3031_R01").then((res) => {
            setAuth(res.data);
        });
    }, []);

    useEffect(() => {
        if (!menuCdStore) {
            console.log("[ProductResultContent] menuCd가 없습니다. 메뉴를 선택하세요.");
        } else {
            console.log("[ProductResultContent] menuCd:" + menuCdStore);
        }
    }, [menuCdStore]);

	const getParams = (filter: Partial<PRD3031_R01Filter>) => {
		return {
			compCd: filter.compCd,
			productDateRange: filter.productDateRange,
			orderType: filter.orderType,
			workplaceCd: filter.workplaceCd,
			itemCd: filter.itemCd,
			brandCd: filter.brandCd
		};
	}

	const renewalAllCount = useCallback(async () => {
		const response = await getPRD3031_R01AllCount(getParams(PRD3031_R01Filter));
		setAllCount(response.data.data);
		return response.data.data;
	}, [PRD3031_R01Filter, setAllCount]);

    const fetchData = useCallback(async () => {
        setLoadingSpinner(true);
        setScrollTop(null);
        try {

            const response = await getPRD3031_R01List(
                '',
                getParams(PRD3031_R01Filter),
                PRD3031_R01List.length ?? 0
            );

            const rawData = response.data.data as PRD3031_R01Dto[];
            
            const extendedRawData: ExtendedPRD3031_R01Dto[] = rawData.map(item => ({
                ...item,
                isSubtotal: false
            }));

			const newList = [...extendedRawData ] as ExtendedPRD3031_R01Dto[];
			setPRD3031_R01List(newList);

            const processAllCount = await renewalAllCount();

            if (newList && newList.length > 0) {
                setPRD3031_R01PastFilter(PRD3031_R01Filter);
                setPRD3031_R01List(newList);
                ShowSuccessFetch(setMessage, `조회가 완료되었습니다. (총 ${newList.length}/${processAllCount}건)`);
            } else {
                showWarning('데이터가 없습니다.');
                setPRD3031_R01List([]);
            }
        } catch (error) {
            console.error('데이터 조회 실패:', error);
            showWarning('데이터 조회에 실패했습니다.');
            setPRD3031_R01List([]);
        } finally {
            setLoadingSpinner(false);
        }
    }, [PRD3031_R01Filter, setPRD3031_R01List, setPRD3031_R01PastFilter, setScrollTop]);
    
    const handleExcelClick = async () => {
        const {isDefaultFilter, isDefaultPastFilter, listLength} = fetchFilterConfig(
            PRD3031_R01Filter,
            PRD3031_R01PastFilter,
            defaultPRD3031_R01Filter,
            PRD3031_R01List.length
        );

        const response = await exportPRD3031_R01Excel(
            isDefaultFilter? '' : 'search',
            getParams(PRD3031_R01Filter),
            listLength
        );
        const binaryString = atob(response.data.data);
        const byteArray = new Uint8Array(binaryString.length);
        for (let i = 0; i < binaryString.length; i++) {
            byteArray[i] = binaryString.charCodeAt(i);
        }
        const blob = new Blob([byteArray]);
        downloadExcel(blob, '생산실적 조회-excel.xlsx');
    };

    return {
        fetchData,
        handleExcelClick,
    };
};
